import { _delete, _get, _patch, _post, getUrlQueryParameterFromObject } from './apiClient'

export const URL_BASE_COMMENTS = 'comments'

export function deleteCommentById (id) {
  const url = `${URL_BASE_COMMENTS}/${id}/`
  return _delete(url)
}

export function updateCommentById (id, data) {
  const url = `${URL_BASE_COMMENTS}/${id}/`
  return _patch(url, data)
}

export function getComments (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_COMMENTS}/?${queryParams}`
  return _get(url)
}

export function createComment (commentData) {
  const url = `${URL_BASE_COMMENTS}/`
  return _post(url, commentData)
}

export function getCommentsByEntity (entityId, relationName) {
  const query = {
    [relationName]: entityId,
    ordering: 'created',
  }

  return getComments(query)
}

export function createCommentsByEntity (entityId, commentData, relationName) {
  const data = Object.assign(commentData, { [relationName]: entityId })
  return createComment(data)
}
